var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelephoneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.1885 21.3734C25.1959 20.3734 22.7921 18.9141 21.6259 18.326C20.1071 17.5611 19.9821 17.4986 18.7883 18.3854C17.992 18.9772 17.4626 19.506 16.5307 19.3072C15.5988 19.1085 13.5738 17.9879 11.8006 16.2205C10.0275 14.4531 8.8418 12.3694 8.64242 11.4407C8.44304 10.512 8.98055 9.98888 9.56682 9.19079C10.3931 8.06584 10.3306 7.87835 9.62432 6.35966C9.07368 5.17846 7.57177 2.79732 6.56799 1.80986C5.49422 0.74928 5.49422 0.936772 4.80233 1.22426C4.23904 1.46124 3.69865 1.74931 3.18791 2.08485C2.18789 2.74919 1.63287 3.30104 1.24474 4.13038C0.856604 4.95972 0.682225 6.90402 2.68665 10.5451C4.69107 14.1862 6.09736 16.048 9.00805 18.9504C11.9187 21.8527 14.1569 23.4133 17.4289 25.2482C21.4765 27.515 23.029 27.0731 23.8609 26.6857C24.6928 26.2982 25.2472 25.7482 25.9128 24.7482C26.2493 24.2384 26.538 23.6986 26.7754 23.1358C27.0635 22.4465 27.251 22.4465 26.1885 21.3734Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelephoneIcon);
export default __webpack_public_path__ + "static/media/telephoneIcon.1cdaf5c20e3c0591cacf2f1db58a6124.svg";
export { ForwardRef as ReactComponent };